export default __webpack_public_path__ + "static/media/Condiciones generales_ 1a convocatoria base de jurados 2025_def (1).e95ded75.pdf";